import { Injectable } from '@angular/core';
import { ApiService } from './http/api.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private api: ApiService) { }

  // receive(): any {
  //   const itemRef = this._db.list(environment.notificationRef);

  //   return itemRef.snapshotChanges(['child_added']);

  //   // return itemRef.snapshotChanges(['child_added']).pipe(
  //   //   map(changes => {
  //   //     return changes.map(payload => {
  //   //       if (payload.type === 'child_added') {
  //   //         return undefined;
  //   //       }
  //   //     });
  //   //   })
  //   // );
  // }

  send(username, deviceToken, message): any {
    // const headers = new HttpHeaders()
    //   .set('Content-Type', 'application/json')
    //   .set('Authorization', 'Key=' + environment.firebase.serverKey);

    // const formData = {
    //   to: deviceToken,
    //   notification: {
    //     title: 'แจ้งเตือน',
    //     body: message,
    //     sound: 'default'
    //   }
    // };

    // return this.http.post('https://fcm.googleapis.com/fcm/send', formData, { headers: headers })
    //   .toPromise()
    //   .then(res => {

    //     this.sendForReload(username, message);

    //     return res;
    //   })
    //   .catch(err => err);
  }

  // sendForReload(user, message): any {
  //   const itemRef = this._db.list(environment.notificationReloadRef);

  //   itemRef.push({
  //     user: user,
  //     message: message
  //   });
  // }

  group(companyId): Promise<any> {
    return this.api.get(`/notification/groups?companyId=${companyId}`).toPromise();
  }
}
